export default __webpack_public_path__ + "static/media/wall-clock.e23a0957.png";